import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage, NotificationMessageTemplate, NotificationMessageTemplateWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateNotificationMessageTemplate(): UseMutationResult<
  AxiosResponse<NotificationMessageTemplate>,
  AxiosError<ErrorMessage>,
  NotificationMessageTemplateWrite
> {
  const queryClient = useQueryClient();

  const createNotificationMessageTemplate = (
    notificationMessageTemplate: NotificationMessageTemplateWrite,
  ): Promise<AxiosResponse<NotificationMessageTemplate>> => {
    return client.post('notification-message-templates/', notificationMessageTemplate);
  };

  return useMutation(createNotificationMessageTemplate, {
    onSuccess: () => {
      queryClient.invalidateQueries('notificationMessageTemplates');
    },
  });
}
